import { InsightsList } from './InsightsList';

export default {
    list: InsightsList,
};